import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Artists from './components/Artists';
import Events from './components/Events';
import Dubplates from './components/Dubplates';
import Releases from './components/Releases';
import Testimonials from './components/Testimonials';
import DemoSubmission from './components/DemoSubmission';
import Footer from './components/Footer';
import VIP from './components/VIP';
import Login from './components/Login';
import Register from './components/Register';
import VIPSuccess from './components/VIPSuccess';
import VIPCancel from './components/VIPCancel';
import MemberPortal from './components/MemberPortal';
import AdminDashboard from './components/AdminDashboard';
import EventBanner from './components/EventBanner';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Homepage Component
const Homepage = () => (
  <>
    <Hero />
    <About />
    <Artists />
    <Events />
    <Dubplates />
    <Releases />
    <Testimonials />
    <DemoSubmission />
  </>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App bg-black min-h-screen">
          <Navbar />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/vip" element={<VIP />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/vip/success" element={<VIPSuccess />} />
            <Route path="/vip/cancel" element={<VIPCancel />} />
            <Route path="/member" element={<MemberPortal />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
